import classNames from 'classnames'
import React, { ReactNode } from 'react'

const ProductListingSkeleton = () => (
  <section className="productListing">
    {new Array<ReactNode>(8).fill(undefined).map((_r, i) => (
      <div
        key={i}
        className={classNames('skeleton', 'min-h-80 rounded-lg px-4 py-3')}
      />
    ))}
  </section>
)

export default ProductListingSkeleton
